<template>
  <div class="product">
    <h1>Product 页面</h1>
    <p>这是自动生成的 Product 页面</p>
  </div>
</template>

<script setup lang="ts">
// Product 页面的逻辑
console.log('Product 页面加载了');
</script>

<style scoped>
.product {
  padding: 40px;
}
</style>
